import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";
import {GameSessionService} from "../../../services/game-session.service";

@Component({
  selector: 'brt-game-session-controller-overlay-footer',
  templateUrl: './game-session-controller-overlay-footer.component.html',
  styleUrls: ['./game-session-controller-overlay-footer.component.scss']
})
export class GameSessionControllerOverlayFooterComponent implements Overlayable {

  @Output() onClosed = new EventEmitter<boolean>();

  gameSessionActive = false;
  gameSessionPaused = false;

  constructor(
    private gameSessionService: GameSessionService
  ) {

    this.gameSessionService.gameSessionActive$.subscribe(response => {
      this.gameSessionActive = response;
    });

    this.gameSessionService.gameSessionPaused$.subscribe(response => {
      this.gameSessionPaused = response;
    });

  }

  endGameSession() {
    this.gameSessionService.endGameSession();
    this.onClosed.emit(true);
  }

  pauseGameSession() {
    this.gameSessionService.pauseGameSession();
  }

  resumeGameSession() {
    this.gameSessionService.resumeGameSession();
  }
}
